 export default function LougoutComponent(){
    return(
        <div className="footer">
            <h1>You are logged out!</h1>
         <div>
            Thank you for using the app. Come back again!
         </div>
        </div>
    )
}